import {useEffect, useState} from "react";

import "./Contador.scss";

function Contador(props) {

    let provincia = document.querySelector('#hmg_react_app').getAttribute('data-provincia');
    let poblacion = document.querySelector('#hmg_react_app').getAttribute('data-poblacion');
    let pagePath = window.location.pathname;
    let pageTitle = pagePath.split('/')[2];

    let iniciaContent;

    if (document.querySelector("#content")) {
        //condición para que no coja el datalayer edad en la portada
        iniciaContent = document.querySelector("#content").classList.contains('inicia');
    } else {
        iniciaContent = false;
    }

    //función para cambiar la segunda parte del contador
    function datalayer() {
        const number_page = document.querySelector(".form__contador__pages");

        if (props.count === 2) {

            if (iniciaContent) {
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    'event': 'virtualPage',
                    'pagePath': 'vpv' + pagePath + '/edad',
                    'pageTittle': 'La casa que eres - ' + pageTitle + ' - Edad',
                    'tipoPagina': 'formulario', // agrupacion contenido CG1
                    'subtipoPagina': 'la casa que eres', // agrupacion contenido CG2
                    'provincia': provincia, // agrupacion contenido CG3
                    'localidad': poblacion, // agrupacion contenido CG4
                    'idioma': 'es' // agrupacion contenido CG5
                });
            } else {
                iniciaContent = true;
            }
            // number_page.setAttribute("style", "color: white");

        } else if (props.count === 3) {
            // number_page.setAttribute("style", "color: #808080");
            //pusheamos datalayer
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'event': 'virtualPage',
                'pagePath': 'vpv' + pagePath + '/habitaciones',
                'pageTittle': 'La casa que eres - ' + pageTitle + ' - Habitaciones',
                'tipoPagina': 'formulario', // agrupacion contenido CG1
                'subtipoPagina': 'la casa que eres', // agrupacion contenido CG2
                'provincia': provincia, // agrupacion contenido CG3
                'localidad': poblacion, // agrupacion contenido CG4
                'idioma': 'es' // agrupacion contenido CG5
            });

        } else if (props.count === 4) {
            // number_page.setAttribute("style", "color: white");
            //pusheamos datalayer
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'event': 'virtualPage',
                'pagePath': 'vpv' + pagePath + '/metros',
                'pageTittle': 'La casa que eres - ' + pageTitle + ' - Metros',
                'tipoPagina': 'formulario', // agrupacion contenido CG1
                'subtipoPagina': 'la casa que eres', // agrupacion contenido CG2
                'provincia': provincia, // agrupacion contenido CG3
                'localidad': poblacion, // agrupacion contenido CG4
                'idioma': 'es' // agrupacion contenido CG5
            });

        } else if (props.count === 5) {
            // number_page.setAttribute("style", "color: #808080");
            //pusheamos datalayer
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'event': 'virtualPage',
                'pagePath': 'vpv' + pagePath + '/suelo',
                'pageTittle': 'La casa que eres - ' + pageTitle + ' - Suelo',
                'tipoPagina': 'formulario', // agrupacion contenido CG1
                'subtipoPagina': 'la casa que eres', // agrupacion contenido CG2
                'provincia': provincia, // agrupacion contenido CG3
                'localidad': poblacion, // agrupacion contenido CG4
                'idioma': 'es' // agrupacion contenido CG5
            });
        } else if (props.count === 6) {
            // number_page.setAttribute("style", "color: #808080");
            //pusheamos datalayer
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'event': 'virtualPage',
                'pagePath': 'vpv' + pagePath + '/paredes',
                'pageTittle': 'La casa que eres - ' + pageTitle + ' - Paredes',
                'tipoPagina': 'formulario', // agrupacion contenido CG1
                'subtipoPagina': 'la casa que eres', // agrupacion contenido CG2
                'provincia': provincia, // agrupacion contenido CG3
                'localidad': poblacion, // agrupacion contenido CG4
                'idioma': 'es' // agrupacion contenido CG5
            });
        } else if (props.count === 7) {
            // number_page.setAttribute("style", "color: white");
            //pusheamos datalayer
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'event': 'virtualPage',
                'pagePath': 'vpv' + pagePath + '/cocina',
                'pageTittle': 'La casa que eres - ' + pageTitle + ' - Cocina',
                'tipoPagina': 'formulario', // agrupacion contenido CG1
                'subtipoPagina': 'la casa que eres', // agrupacion contenido CG2
                'provincia': provincia, // agrupacion contenido CG3
                'localidad': poblacion, // agrupacion contenido CG4
                'idioma': 'es' // agrupacion contenido CG5
            });
        } else if (props.count === 8) {
            // number_page.setAttribute("style", "color: #808080");
            //pusheamos datalayer
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'event': 'virtualPage',
                'pagePath': 'vpv' + pagePath + '/detalles',
                'pageTittle': 'La casa que eres - ' + pageTitle + ' - Detalles',
                'tipoPagina': 'formulario', // agrupacion contenido CG1
                'subtipoPagina': 'la casa que eres', // agrupacion contenido CG2
                'provincia': provincia, // agrupacion contenido CG3
                'localidad': poblacion, // agrupacion contenido CG4
                'idioma': 'es' // agrupacion contenido CG5
            });

        } else if (props.count === 9) {
            // number_page.setAttribute("style", "color: white");
            //pusheamos datalayer
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'event': 'virtualPage',
                'pagePath': 'vpv' + pagePath + '/aseo',
                'pageTittle': 'La casa que eres - ' + pageTitle + ' - Aseo',
                'tipoPagina': 'formulario', // agrupacion contenido CG1
                'subtipoPagina': 'la casa que eres', // agrupacion contenido CG2
                'provincia': provincia, // agrupacion contenido CG3
                'localidad': poblacion, // agrupacion contenido CG4
                'idioma': 'es' // agrupacion contenido CG5
            });
        } else if (props.count === 10) {
            // number_page.setAttribute("style", "color: #808080");
            //pusheamos datalayer
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'event': 'virtualPage',
                'pagePath': 'vpv' + pagePath + '/bide',
                'pageTittle': 'La casa que eres - ' + pageTitle + ' - Bidé',
                'tipoPagina': 'formulario', // agrupacion contenido CG1
                'subtipoPagina': 'la casa que eres', // agrupacion contenido CG2
                'provincia': provincia, // agrupacion contenido CG3
                'localidad': poblacion, // agrupacion contenido CG4
                'idioma': 'es' // agrupacion contenido CG5
            });
        } else if (props.count === 11) {
            // number_page.setAttribute("style", "color: #808080");
            //pusheamos datalayer
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'event': 'virtualPage',
                'pagePath': 'vpv' + pagePath + '/personalizacion',
                'pageTittle': 'La casa que eres - ' + pageTitle + ' - Personalización',
                'tipoPagina': 'formulario', // agrupacion contenido CG1
                'subtipoPagina': 'la casa que eres', // agrupacion contenido CG2
                'provincia': provincia, // agrupacion contenido CG3
                'localidad': poblacion, // agrupacion contenido CG4
                'idioma': 'es' // agrupacion contenido CG5
            });
        } else if (props.count === 12) {
            // number_page.setAttribute("style", "color: #808080");
            //pusheamos datalayer
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'event': 'virtualPage',
                'pagePath': 'vpv' + pagePath + '/prioridad',
                'pageTittle': 'La casa que eres - ' + pageTitle + ' - Prioridad',
                'tipoPagina': 'formulario', // agrupacion contenido CG1
                'subtipoPagina': 'la casa que eres', // agrupacion contenido CG2
                'provincia': provincia, // agrupacion contenido CG3
                'localidad': poblacion, // agrupacion contenido CG4
                'idioma': 'es' // agrupacion contenido CG5
            });
        } else if (props.count === 13) {
            // number_page.setAttribute("style", "color: #808080");
            //pusheamos datalayer
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'event': 'virtualPage',
                'pagePath': 'vpv' + pagePath + '/garaje',
                'pageTittle': 'La casa que eres - ' + pageTitle + ' - Garaje',
                'tipoPagina': 'formulario', // agrupacion contenido CG1
                'subtipoPagina': 'la casa que eres', // agrupacion contenido CG2
                'provincia': provincia, // agrupacion contenido CG3
                'localidad': poblacion, // agrupacion contenido CG4
                'idioma': 'es' // agrupacion contenido CG5
            });
        } else if (props.count === 14) {
            // number_page.setAttribute("style", "color: #808080");
            //pusheamos datalayer
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'event': 'virtualPage',
                'pagePath': 'vpv' + pagePath + '/extras',
                'pageTittle': 'La casa que eres - ' + pageTitle + ' - Extras',
                'tipoPagina': 'formulario', // agrupacion contenido CG1
                'subtipoPagina': 'la casa que eres', // agrupacion contenido CG2
                'provincia': provincia, // agrupacion contenido CG3
                'localidad': poblacion, // agrupacion contenido CG4
                'idioma': 'es' // agrupacion contenido CG5
            });

        } else if (props.count === 15) {
            // number_page.setAttribute("style", "color: #808080");
            //pusheamos datalayer
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'event': 'virtualPage',
                'pagePath': 'vpv' + pagePath + '/espacios-comunes',
                'pageTittle': 'La casa que eres - ' + pageTitle + ' - Espacios comunes',
                'tipoPagina': 'formulario', // agrupacion contenido CG1
                'subtipoPagina': 'la casa que eres', // agrupacion contenido CG2
                'provincia': provincia, // agrupacion contenido CG3
                'localidad': poblacion, // agrupacion contenido CG4
                'idioma': 'es' // agrupacion contenido CG5
            });

        } else if (props.count === 16) {
            // number_page.setAttribute("style", "color: #808080");
            //pusheamos datalayer
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'event': 'virtualPage',
                'pagePath': 'vpv' + pagePath + '/cuota-mensual',
                'pageTittle': 'La casa que eres - ' + pageTitle + ' - Cuota mensual',
                'tipoPagina': 'formulario', // agrupacion contenido CG1
                'subtipoPagina': 'la casa que eres', // agrupacion contenido CG2
                'provincia': provincia, // agrupacion contenido CG3
                'localidad': poblacion, // agrupacion contenido CG4Ω
                'idioma': 'es' // agrupacion contenido CG5
            });

        } else if (props.count === 17) {
            // number_page.setAttribute("style", "color: #808080");
            //pusheamos datalayer
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'event': 'virtualPage',
                'pagePath': 'vpv' + pagePath + '/cuota-comentarios',
                'pageTittle': 'La casa que eres - ' + pageTitle + ' - Comentarios',
                'tipoPagina': 'formulario', // agrupacion contenido CG1
                'subtipoPagina': 'la casa que eres', // agrupacion contenido CG2
                'provincia': provincia, // agrupacion contenido CG3
                'localidad': poblacion, // agrupacion contenido CG4Ω
                'idioma': 'es' // agrupacion contenido CG5
            });
        } else if (props.count === 18) {
            // number_page.setAttribute("style", "color: #808080");
            //pusheamos datalayer
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'event': 'virtualPage',
                'pagePath': 'vpv' + pagePath + '/formulario',
                'pageTittle': 'La casa que eres - ' + pageTitle + ' - Formulario',
                'tipoPagina': 'formulario', // agrupacion contenido CG1
                'subtipoPagina': 'la casa que eres', // agrupacion contenido CG2
                'provincia': provincia, // agrupacion contenido CG3
                'localidad': poblacion, // agrupacion contenido CG4Ω
                'idioma': 'es' // agrupacion contenido CG5
            });
        }
    }

    //inicialización de la función
    useEffect(() => {
        datalayer();
    }, [props.count])

    return (
        <div className="container d-flex justify-content-center">
            <div className="form__contador align-items-center">
                <p className="d-inline mb-0">{props.count}/</p>
                <p className="form__contador__pages d-inline mb-0">17</p>
            </div>
        </div>
    )
}

export default Contador;
